
const config = {
  "account": {
    "contact": "garrett@neurograph.io",
    "id": "neurograph",
    "imageUrl": "https://storage.googleapis.com/axon-cdn-dev/organization/neurograph/assets/img/profile.png"
  },
  "assets": {
    "img": {
      "brand": {
        "backgrounds": {
          "profile": "https://storage.googleapis.com/axon-cdn-dev/organization/neurograph/assets/img/brand/backgrounds/profile.png"
        },
        "logo": "https://storage.googleapis.com/axon-cdn-dev/organization/neurograph/assets/img/brand/logo.png",
        "logo-white": "https://storage.googleapis.com/axon-cdn-dev/organization/neurograph/assets/img/brand/logo-white.png"
      }
    }
  },
  "footer": {
    "company": {
      "link": "https://neurograph.io",
      "name": "NeuroGraph, Inc."
    }
  },
  "theme": {
    "palette": {
      "color-1": "#0A0F1D",
      "color-2": "#1E3D59",
      "color-3": "#2ECC71",
      "color-4": "#6B4E87",
      "color-5": "#8492A6"
    }
  }
}

export default config;
